const europe={name:"Europe",codes:["EU","EUR","000"],calcFn:()=>!0,rules:{multipliers:{},regex:[/^(EU)(\d{9})$/]}};export{europe};